var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-edit-dialog', _vm._g({
    attrs: {
      "return-value": _vm.item.memo,
      "large": "",
      "cancel-text": "취소",
      "save-text": "저장"
    },
    on: {
      "update:returnValue": function updateReturnValue($event) {
        return _vm.$set(_vm.item, "memo", $event);
      },
      "update:return-value": function updateReturnValue($event) {
        return _vm.$set(_vm.item, "memo", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function fn() {
        return [_c('v-sheet', {
          staticClass: "pt-3"
        }, [_c('v-text-field', {
          attrs: {
            "hide-details": "",
            "dense": "",
            "outlined": ""
          },
          model: {
            value: _vm.item.index,
            callback: function callback($$v) {
              _vm.$set(_vm.item, "index", $$v);
            },
            expression: "item.index"
          }
        })], 1)];
      },
      proxy: true
    }])
  }, {
    save: _vm.save
  }), [_vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }